import React, { useState } from 'react';
import AsyncSelect from 'react-select/async';
import axios from 'axios';
import { toast } from 'react-toastify';

var _ = require('lodash');

const debouncedConfirmFetch = _.debounce((inputValue, callback, team) => {
  new Promise(resolve => {
    axios.get('/teams/' + team.id + '/calendar_events/autocomplete', {
        params: {
          name: inputValue
        }
      })
      .then(function (response) {
        var options = response.data.map(function(data){
          return { value: data.id, label: data.name };
        });

        callback(options);
      })
  });
}, 250);

const selectStyles = {
  container: (base, state) => ({
    ...base,
    opacity: state.isDisabled ? ".5" : "1",
    backgroundColor: "transparent",
    zIndex: "999"
  }),
  menuPortal: base => ({ ...base, zIndex: 9999 }),
  menu: provided => ({ ...provided, zIndex: "9999 !important" })
};

const V3LinkOfferModal = ({ team, csrfToken, offer, onClose, onSuccess }) => {
  const [calendarEvent, setCalendarEvent] = useState({});
  const [isSaving, setIsSaving] = useState(false);

  const canSubmitForm = () => {
    return (
      calendarEvent
        && calendarEvent.value
        && !isSaving
    );
  };

  const submitForm = () => {
    setIsSaving(true);

    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    axios.post("/teams/" + team.id + "/offers/v3/" + offer.id + "/link_lineup", {
      calendar_event_id: calendarEvent.value,
    })
    .then(() => {
      onSuccess();
    })
    .catch((error) => {
      onError(error);
      setIsSaving(false);
    });
  };

  const onError = (error) => {
    var message = error.response && error.response.data
      ? (Array.isArray(error.response.data) ? error.response.data.join(", ") : "Failed to link offer")
      : "Failed to link offer";
    toast.error(message, {
      position: toast.POSITION.TOP_CENTER,
      draggable: false,
      closeOnClick: false,
      autoClose: 5000,
      hideProgressBar: true
    });
  };

  return(<div className="offer-modal-container"
       style={{"padding": "30px 40px"}}>
    <div className="row">
      <div className="col">
        <h3 style={{"fontSize": "20px"}}>
          <strong>Link Offer</strong>
        </h3>
      </div>
      <div className="col-xs-auto"
           style={{"paddingRight": "15px"}}>
        <a href="#"
           onClick={
             (e) => {
               e.preventDefault();
               onClose();
             }
           }
           style={{"fontSize": "26px"}}
           className="text-dark">
          <i className="fal fa-times"></i>
        </a>
      </div>
    </div>
    <div className="row">
      <div className="col-12">
        <p className="text-muted"
           style={{"fontSize": "16px"}}>
           Link this offer with an existing event on your calendar.
        </p>
      </div>
    </div>
    <div className="row">
      <div className="col-12">
        <form onSubmit={
                (e) => {
                  e.preventDefault();

                  if(!canSubmitForm(calendarEvent)){
                    return false;
                  }

                  submitForm();
                }
              }>
          <div className="row">
            <div className="col-12">
              <AsyncSelect cacheOptions
                           placeholder={"Select event"}
                           isClearable={true}
                           classNamePrefix="link-offer-select"
                           styles={selectStyles}
                           menuPortalTarget={document.querySelector('body')}
                           defaultOptions
                           onChange={
                             (option) => {
                               setCalendarEvent(option || {});
                             }
                           }
                           value={Object.keys(calendarEvent).length > 0 ? calendarEvent : ""}
                           loadOptions={(inputValue, callback) => debouncedConfirmFetch(inputValue, callback, team)} />
            </div>
          </div>
          <div className="row small" style={{"marginTop": "30px"}}>
            <div className="col-12 text-right">
              <a href="#"
                 onClick={
                   (e) => {
                     e.preventDefault();
                     onClose();
                   }
                 }>
                <strong>Cancel</strong>
              </a>
              <input type="submit"
                     style={{"borderRadius": "8px"}}
                     className="btn btn-primary btn-sm ml-3 strong"
                     disabled={!canSubmitForm(calendarEvent)}
                     value="Save" />
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>);
};

export default V3LinkOfferModal;
